export enum CommandItemType {
  Navigate,
  Callback,
  Input,
  Banner,
}

interface BaseMeta {
  type: CommandItemType;
}

export interface NavigateMeta extends BaseMeta {
  type: CommandItemType.Navigate;
  link: string;
  inNewTab?: boolean;
}

export interface CallbackMeta extends BaseMeta {
  type: CommandItemType.Callback;
  callback: () => void;
}

export interface InputMeta extends BaseMeta {
  type: CommandItemType.Input;
  getItems: GetCommandItems;
}

export interface BannerItemType extends BaseMeta {
  type: CommandItemType.Banner;
}

export type CommandItemMeta =
  | NavigateMeta
  | CallbackMeta
  | InputMeta
  | BannerItemType;

export interface CommandItem {
  label: string;
  name: string;
  meta: CommandItemMeta;
  icon?: React.FC;
  desc?: string;
}

export type GetCommandItems = (filterText: string) => Promise<CommandItem[]>;

export interface CommandGroup {
  groupId: number;
  label: string;
  name: string;
  filterable: boolean;
  tabbable: boolean;
  getCommandItems: GetCommandItems;
}
